module.exports = "/_next/static/images/CombineData-6c832e38db0b800c3b1d808dba7e33a4.webp";